import { Show, useContext } from 'solid-js';
import clsx from 'clsx';
import { AppContext } from '../../app-context-provider/app-context-provider';

export const PostCardPlaceholder = (props: { loaded?: boolean }) => {
    const { localize } = useContext(AppContext);

    return (
        <div
            aria-hidden={props.loaded}
            class={clsx(
                'flex flex-col gap-cvi-6 transition-opacity',
                props.loaded ? 'opacity-0 pointer-events-none' : 'opacity-100',
            )}
        >
            <div class="aspect-[29/16] w-full rounded-cvi-md bg-cvi-bg-neutral-subtle" />
            <Show when={!props.loaded}>
                <div class="flex flex-col gap-cvi-4">
                    <span class="label-sm font-cvi-medium text-cvi-fg-muted">
                        {localize('loading', 'Loading...')}
                    </span>
                </div>
            </Show>
        </div>
    );
};
